// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customize the label (the checkbox) */
.checkbox_WOuy0 {
  font-size : 14px;
  width : 24px;
  height : 24px;
}
.checkbox_WOuy0 .appearance_g7rwg {
  border: 1px solid #D2D2D2;
  border-radius: 2px;
  padding: 4px;
  background: white;
}
.checkbox_WOuy0:hover .appearance_g7rwg {
  background: #D2D2D2;
}

.checkbox_WOuy0[data-value=true] .appearance_g7rwg {
  background: #5A5CE2;
}

.checkbox_WOuy0 .icon_kjjcI { 
  color : white;
}

.checkbox_WOuy0:hover .icon_kjjcI { 
  color : #D2D2D2;
}

/* On mouse-over, add a grey background color */
.checkbox_WOuy0 .appearance_g7rwg, .checkbox_WOuy0 .appearance_g7rwg .icon_kjjcI {
  -webkit-transition : background-color 0.2s, opacity 0.2s;
  transition : background-color 0.2s, opacity 0.2s;
}


/* When the checkbox is checked, add a blue background */
.checkbox_WOuy0 input:focus ~ .appearance_g7rwg {
  border-color: #5A5CE2;
}

.checkbox_WOuy0.checkbox-small_W4znB {
  font-size : 8px;
  width : 18px;
  height : 18px;
  padding:2px;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Checkbox.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,wDAAgD;EAAhD,gDAAgD;AAClD;;;AAGA,wDAAwD;AACxD;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;AACb","sourcesContent":["/* Customize the label (the checkbox) */\n.checkbox {\n  font-size : 14px;\n  width : 24px;\n  height : 24px;\n}\n.checkbox .appearance {\n  border: 1px solid #D2D2D2;\n  border-radius: 2px;\n  padding: 4px;\n  background: white;\n}\n.checkbox:hover .appearance {\n  background: #D2D2D2;\n}\n\n.checkbox[data-value=true] .appearance {\n  background: #5A5CE2;\n}\n\n.checkbox .icon { \n  color : white;\n}\n\n.checkbox:hover .icon { \n  color : #D2D2D2;\n}\n\n/* On mouse-over, add a grey background color */\n.checkbox .appearance, .checkbox .appearance .icon {\n  transition : background-color 0.2s, opacity 0.2s;\n}\n\n\n/* When the checkbox is checked, add a blue background */\n.checkbox input:focus ~ .appearance {\n  border-color: #5A5CE2;\n}\n\n.checkbox.checkbox-small {\n  font-size : 8px;\n  width : 18px;\n  height : 18px;\n  padding:2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox_WOuy0`,
	"appearance": `appearance_g7rwg`,
	"icon": `icon_kjjcI`,
	"checkbox-small": `checkbox-small_W4znB`
};
export default ___CSS_LOADER_EXPORT___;
